import styled from "@emotion/styled";

export const LeadAssignmentFiltersContainer = styled.div({
	display: "flex",
	gap: "8px",
	flexWrap: "wrap"
});
